<div class="toast">
    <div class="icon">
        <img src="assets/img/x-danger.png" alt="error">
    </div>
    <span *ngIf="!data?.hasBulkUploadError" class="message">{{data?.msg}}</span>
    <span *ngIf="data?.hasBulkUploadError" class="message" [innerHTML]="data?.msg"></span>
</div>